import { render, staticRenderFns } from "./vertical-tabs-component.vue?vue&type=template&id=57f0abae&scoped=true&"
import script from "./vertical-tabs-component.vue?vue&type=script&lang=ts&"
export * from "./vertical-tabs-component.vue?vue&type=script&lang=ts&"
import style0 from "./vertical-tabs-component.vue?vue&type=style&index=0&id=57f0abae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0abae",
  null
  
)

export default component.exports